// extracted by mini-css-extract-plugin
export default {"button":"bl-z","reviewSort":"cl-z"};